import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { API_ENDPOINTS } from "../../../../util/constants";
import { actionTypes } from "../../../Auth/_redux/authRedux";
import { actions } from "../../../Dashboard/_redux/dashboardRedux";

const initialListingsState = {
  agentList: [],
  queueList: [],
  stickyAgentList: [],
  stickyAgentMeta: {},
};

export const fetchQueueLists = createAsyncThunk(
  "stickyAgentSlice/fetchQueueLists",
  async ({ dispatch, rejectWithValue }) => {
    try {
      const response = await axios.get(API_ENDPOINTS.getQueueDetails);
      return await response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);

export const fetchAgentLists = createAsyncThunk(
  "stickyAgentSlice/fetchAgentLists",
  async ({ dispatch, rejectWithValue }) => {
    try {
      const response = await axios.get(API_ENDPOINTS.getstickyAgentDetails);
      return await response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);

export const fetchStickyAgentLists = createAsyncThunk(
  "stickyAgentSlice/fetchStickyAgentLists",
  async (params, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.post(
        API_ENDPOINTS.getAgentMappedData,
        params
      );
      return await response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);
export const deleteStickyAgent = createAsyncThunk(
  "stickyAgentSlice/deleteStickyAgent",
  async (params, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.delete(API_ENDPOINTS.deleteStickyAgent, {
        data: params,
      });

      dispatch(
        actions.setLoadingState({
          resource: "stickyAgent_lists",
          loading_state: "loaded",
        })
      );
      return await response;
    } catch (error) {
      return rejectWithValue({ error: error.message });
    }
  }
);

export const stickyAgentSlice = createSlice({
  name: "stickyAgentSlice",
  initialState: { ...initialListingsState },

  extraReducers: (builder) => {
    builder.addCase(actionTypes.Logout, (state, action) => {
      return { ...initialListingsState };
    });

    builder.addCase(fetchStickyAgentLists.pending, (state) => {
      state.stickyAgentList = [];
    });
    builder.addCase(fetchAgentLists.pending, (state) => {
      state.agentList = [];
    });
    builder.addCase(fetchQueueLists.pending, (state) => {
      state.queueList = [];
    });
    builder.addCase(fetchStickyAgentLists.fulfilled, (state, { payload }) => {
      const { data } = payload;

      state.stickyAgentList = data.data;
      state.stickyAgentMeta = data.meta;
    });
    builder.addCase(fetchAgentLists.fulfilled, (state, { payload }) => {
      const { data } = payload;
      state.agentList = data.objects;
    });
    builder.addCase(fetchQueueLists.fulfilled, (state, { payload }) => {
      const { data } = payload;

      state.queueList = data.objects;
    });
    builder.addCase(fetchStickyAgentLists.rejected, (state, action) => {});
    builder.addCase(fetchAgentLists.rejected, (state, action) => {});
  },
  reducers: {
    resetStickyAgentList: (state, action) => {
      state.stickyAgentList = [];
    },
  },
});
export const { resetStickyAgentList } = stickyAgentSlice.actions;
